import { Grid, Box, Typography, makeStyles } from '@material-ui/core'
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'
import styles from './styles'

const useStyles = makeStyles(styles)

export default function ListDocuments() {
  const classes = useStyles()

  return (
    <Grid item xs={12} sm={12} md={12} lg={12}>
      <Box className={classes.container}>
        <Box className={classes.iconContainer}>
          <InsertDriveFileIcon className={classes.fileIcon} />
        </Box>
        <Box className={classes.documentInfo}>
          <OpenInNewIcon className={classes.openIcon} />
          <Typography color="textPrimary" variant="body1">
            Documento 1
          </Typography>
        </Box>
      </Box>
    </Grid>
  )
}
